<template>
  <div class="list-item" :class="{'list-item--fixed-label-width': labelWidthInPx}" :style="`--label-width: ${labelWidthInPx}px`">
    <div class="list-item__label">
      <h6 class="mb-0">
        <font-awesome-icon
          v-if="icon"
          class="text-primary mr-2"
          :icon="['fad', icon]"
          fixed-width
        ></font-awesome-icon>
        {{ title }}
      </h6>
    </div>
    <div class="list-item__content" :class="textClass || 'text-secondary'">
      {{ text || '/' }}
    </div>
  </div>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
  name: "list-item",
  props: {
    icon: {
      type: String,
      required: false
    },
    title: {
      type: String,
    },
    text: {
      type: String,
    },
    textClass: {
      type: String,
      required: false,
    },
    labelWidthInPx: {
      type: Number,
      required: false,
    },
  },
});
</script>

<style scoped>
.list-item + .list-item {
  margin-block-start: 8px;
}

.list-item__label, .list-item__content {
  width: 100%;
}

@media (min-width: 576px) {
  .list-item {
    display: flex;
    align-items: baseline;
  }
   
  .list-item__label {
    flex-basis: 33.3%;
    flex-grow: 0;
    flex-shrink: 0;
  }

  .list-item__content {
    flex-basis: 66.6%;
    flex-grow: 0;
    flex-shrink: 0;
  }
  
  .list-item--fixed-label-width .list-item__label {
    flex-basis: var(--label-width);
  }

  .list-item--fixed-label-width .list-item__content {
    flex-grow: 1;
  }
}

</style>